import type { AnniversaryGift, Maybe } from "@shared/graphql.types";
import { cloudinaryLoader } from "@shared/utils.cloudinary";
import { getRegion } from "@shared/utils.locale";
import Image from "next/image";

import { AnniversaryGiftProductCard } from "../AnniversaryGiftProductCard/AnniversaryGiftProductCard";

import { giftGrid } from "./AnniversaryGftProductGrid.css";

type AnniversaryGiftProductGridProps = {
  gifts?: Maybe<AnniversaryGift>[];
  setNextVisibility?: (visible: boolean) => void;
  elementClicked?: (payload: Record<string, unknown>) => void;
};

export const AnniversaryGiftProductGrid = ({
  gifts = [],
  setNextVisibility,
  elementClicked
}: AnniversaryGiftProductGridProps): JSX.Element => {
  const region = getRegion();
  const urlPrefix = region === "us" ? "/us" : "";

  return (
    <div data-testid="anniversary-gift-product-grid">
      <div className={giftGrid}>
        {gifts
          .filter((gift): gift is AnniversaryGift => !!gift)
          .map((gift, idx) => {
            const href = `${urlPrefix}/products/${gift.slug}`;
            return (
              <AnniversaryGiftProductCard
                key={gift.id}
                gift={gift}
                href={href}
                onClick={() => {
                  setNextVisibility?.(false);
                  elementClicked?.({
                    details: gift.slug,
                    details2: `${idx + 1}`,
                    contentUrl: `${window.location.origin}${href}`
                  });
                }}
              />
            );
          })}
      </div>
      {gifts.length === 0 ? (
        <Image
          priority
          src="https://beautypie.bynder.com/m/ac97a9acdede995/webimage-240317_-_gift_banner0927__1__720.jpg"
          alt="anniversary gift default image"
          quality={100}
          width={409}
          height={292}
          sizes="300px"
          loader={cloudinaryLoader}
        />
      ) : null}
    </div>
  );
};
